import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const AgeVerificationModal = ({ isOpen, onVerify, onCancel }) => {
  const [rememberChoice, setRememberChoice] = useState(false);

  const handleVerify = () => {
    if (rememberChoice) {
      localStorage.setItem('ageVerified', 'true');
    }
    onVerify();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="bg-gray-900 border-gray-700 max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-10 h-10 text-red-500" />
            </div>
          </div>
          <DialogTitle className="text-2xl font-bold text-white text-center">
            Age Verification Required
          </DialogTitle>
          <DialogDescription className="text-gray-400 text-center">
            This content is intended for mature audiences only
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <p className="text-white text-center mb-2">
              You must be <span className="text-orange-500 font-bold">18 years or older</span> to view this content.
            </p>
            <p className="text-gray-400 text-sm text-center">
              By continuing, you confirm that you meet this age requirement.
            </p>
          </div>

          {/* Remember Choice Checkbox */}
          <div className="flex items-start space-x-3">
            <input
              type="checkbox"
              id="remember"
              checked={rememberChoice}
              onChange={(e) => setRememberChoice(e.target.checked)}
              className="mt-1 w-4 h-4 text-orange-500 bg-gray-800 border-gray-600 rounded focus:ring-orange-500 focus:ring-2"
            />
            <label htmlFor="remember" className="text-sm text-gray-300 cursor-pointer">
              Remember my choice (you won't see this again)
            </label>
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-2 gap-4">
            <Button
              onClick={onCancel}
              variant="outline"
              className="bg-transparent border-gray-600 text-gray-300 hover:bg-gray-800 hover:text-white"
            >
              Go Back
            </Button>
            <Button
              onClick={handleVerify}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold"
            >
              I'm 18+
            </Button>
          </div>

          <p className="text-xs text-gray-500 text-center">
            By clicking "I'm 18+", you agree to view mature content and confirm you are of legal age.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AgeVerificationModal;
